















































































































































































import { Vue, Component } from "nuxt-property-decorator";
import LandingSiteCompanies from "~/components/LandingSiteCompanies.vue";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";
import CommonHelpers from "~/helpers/CommonHelpers";

@Component({
  components: { GrPublicFooter, LandingSiteCompanies },
  nuxtI18n: false,
})
export default class RekryteringsforetagPage extends Vue {
  tab = 0;

  get rootUrl(): string {
    return CommonHelpers.getBaseUrl();
  }

  get description(): string {
    return "Dags att rekrytera igen? Välj ett rekryteringsföretag som gör det enkelt, kostnadseffektivt och träffsäkert att hitta den kompetens du söker. Testa Gritify.";
  }

  get title(): string {
    return "Gritify: Rekryteringsföretaget som gör det lätt att rekrytera";
  }

  head() {
    return {
      title: this.title,
      titleTemplate: "%s",
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          property: "og:title",
          content: this.title,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:url",
          content: `${this.rootUrl}${this.$route.path}`,
        },
        {
          property: "og:description",
          content: this.description,
        },
        {
          name: "twitter:title",
          content: this.title,
        },
        {
          name: "twitter:description",
          content: this.description,
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
    };
  }

  get titleFontSize(): string {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
      case "sm":
        return "30px";
      case "md":
        return "40px";
      case "lg":
      case "xl":
        return "60px";
    }
  }

  get wantToKnowMoreLink(): string {
    return this.localePath({
      name: "companyStart",
    });
  }
}
